import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { getToken } from 'services/auth';
import { Navigate } from 'react-router-dom';
import MinimalLayout from 'layout/MinimalLayout';
import ProtectedRoute from './ProtectedRoute';

// dashboard routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const Forgot3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Forgot3')));
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

const AreaNegocio = Loadable(lazy(() => import('views/pages/area-negocio')));
const AreaNegocioForm = Loadable(lazy(() => import('views/pages/area-negocio/form')));

const AlcadaAprovacao = Loadable(lazy(() => import('views/pages/alcada-aprovacao')));
const AlcadaAprovacaoForm = Loadable(lazy(() => import('views/pages/alcada-aprovacao/form')));

const Produto = Loadable(lazy(() => import('views/pages/produto')));
const ProdutoForm = Loadable(lazy(() => import('views/pages/produto/form')));

const Loja = Loadable(lazy(() => import('views/pages/loja')));
const LojaForm = Loadable(lazy(() => import('views/pages/loja/form')));

const ModalidadeFrete = Loadable(lazy(() => import('views/pages/modalidade-frete')));
const ModalidadeFreteForm = Loadable(lazy(() => import('views/pages/modalidade-frete/form')));

const TabelaFinanciamento = Loadable(lazy(() => import('views/pages/tabela-financiamento')));
const TabelaFinanciamentoForm = Loadable(lazy(() => import('views/pages/tabela-financiamento/form')));

const FormaPagamento = Loadable(lazy(() => import('views/pages/forma-pagamento')));
const FormaPagamentoForm = Loadable(lazy(() => import('views/pages/forma-pagamento/form')));

const Bandeira = Loadable(lazy(() => import('views/pages/bandeira')));
const BandeiraForm = Loadable(lazy(() => import('views/pages/bandeira/form')));

const Seller = Loadable(lazy(() => import('views/pages/seller')));
const CadSellerForm = Loadable(lazy(() => import('views/pages/seller/form')));

const GrupoEcon = Loadable(lazy(() => import('views/pages/grupo-economico')));
const GrupoEconForm = Loadable(lazy(() => import('views/pages/grupo-economico/form')));

const FiltroProduto = Loadable(lazy(() => import('views/pages/filtro-produto')));
const FiltroProdutoForm = Loadable(lazy(() => import('views/pages/filtro-produto/form')));

const TipoPromocao = Loadable(lazy(() => import('views/pages/tipo-promocao')));
const TipoPromocaoForm = Loadable(lazy(() => import('views/pages/tipo-promocao/form')));

const TipoPromocaoCampos = Loadable(lazy(() => import('views/pages/tipo-promocao-campos')));
const TipoPromocaoCamposForm = Loadable(lazy(() => import('views/pages/tipo-promocao-campos/form')));

const CategoriaCliente = Loadable(lazy(() => import('views/pages/categoria-cliente')));
const CategoriaClienteForm = Loadable(lazy(() => import('views/pages/categoria-cliente/form')));

const TipoAtributo = Loadable(lazy(() => import('views/pages/tipo-atributo')));
const TipoAtributoForm = Loadable(lazy(() => import('views/pages/tipo-atributo/form')));

const ValorAtributo = Loadable(lazy(() => import('views/pages/valor-atributo')));
const ValorAtributoForm = Loadable(lazy(() => import('views/pages/valor-atributo/form')));

const DominioComercial = Loadable(lazy(() => import('views/pages/dominio-comercial')));
const DominioComercialForm = Loadable(lazy(() => import('views/pages/dominio-comercial/form')));

const CadastroPromocao = Loadable(lazy(() => import('views/pages/cadastro-promocao')));
const CadastroPromocaoForm = Loadable(lazy(() => import('views/pages/cadastro-promocao/form')));

const AprovacaoPendente = Loadable(lazy(() => import('views/pages/aprovacao-pendente')));
const AprovacaoPendenteForm = Loadable(lazy(() => import('views/pages/aprovacao-pendente/form')));

const CalendarioStatus = Loadable(lazy(() => import('views/pages/calendario-status')));

const GeracaoCupom = Loadable(lazy(() => import('views/pages/geracao-cupom')));
const GeracaoCupomForm = Loadable(lazy(() => import('views/pages/geracao-cupom/form')));

const CupomAtendimento = Loadable(lazy(() => import('views/pages/cupom-atendimento')));
const CupomAtendimentoForm = Loadable(lazy(() => import('views/pages/cupom-atendimento/form')));

const SituacaoCupom = Loadable(lazy(() => import('views/pages/situacao-cupom')));

const PerfilAcesso = Loadable(lazy(() => import('views/pages/perfil-acesso')));
const PerfilAcessoForm = Loadable(lazy(() => import('views/pages/perfil-acesso/form')));

const Cargo = Loadable(lazy(() => import('views/pages/cargo')));
const CargoForm = Loadable(lazy(() => import('views/pages/cargo/form')));

const Usuario = Loadable(lazy(() => import('views/pages/usuario')));
const UsuarioForm = Loadable(lazy(() => import('views/pages/usuario/form')));

const TransacaoSistema = Loadable(lazy(() => import('views/pages/transacao-sistema')));
const TransacaoSistemaForm = Loadable(lazy(() => import('views/pages/transacao-sistema/form')));

const ReportsDashboard = Loadable(lazy(() => import('views/pages/reports/dashboard')));
const CuponsReport = Loadable(lazy(() => import('views/pages/reports/cupons')));

const SimuladorPromocao = Loadable(lazy(() => import('views/pages/simulador-promocao')));
const SimuladorPromocaoForm = Loadable(lazy(() => import('views/pages/simulador-promocao/form')));

const GeracaoCupomControleSaldo = Loadable(lazy(() => import('views/pages/geracao-cupom-controle-saldo')));
const GeracaoCupomMultiplosSellers = Loadable(lazy(() => import('views/pages/geracao-cupom-multiplos-sellers')));
const InativacaoCupom = Loadable(lazy(() => import('views/pages/inativacao-cupom')));

const ListaCupom = Loadable(lazy(() => import('views/pages/lista-cupom')));

const Parametro = Loadable(lazy(() => import('views/pages/parametro')));
const ParametroForm = Loadable(lazy(() => import('views/pages/parametro/form')));

const CanalVenda = Loadable(lazy(() => import('views/pages/canal-venda')));
const CanalVendaForm = Loadable(lazy(() => import('views/pages/canal-venda/form')));

const LancamentoBudget = Loadable(lazy(() => import('views/pages/lancamento-budget')));

const MarkDown = Loadable(lazy(() => import('views/pages/documentation')));

const Campanha = Loadable(lazy(() => import('views/pages/comunicacao/campanhas')));
const CampanhaForm = Loadable(lazy(() => import('views/pages/comunicacao/campanhas/form')));

const CanaisDeComunicacao = Loadable(lazy(() => import('views/pages/comunicacao/canais')));
const CanaisDeComunicacaoForm = Loadable(lazy(() => import('views/pages/comunicacao/canais/form')));

const TemplatesComunicacao = Loadable(lazy(() => import('views/pages/comunicacao/templates')));
const TemplatesComunicacaoForm = Loadable(lazy(() => import('views/pages/comunicacao/templates/form')));

const PoliticaPrivacidadeFacebook = Loadable(lazy(() => import('views/pages/politica-privacidade/exclusao-facebook')));
const PoliticaPrivacidade = Loadable(lazy(() => import('views/pages/politica-privacidade')));
const TermosUso = Loadable(lazy(() => import('views/pages/termos-uso')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = (isLoggedIn) => [
    // Rotas de autenticação (apenas para usuários não logados)
    {
        path: '/login',
        element: !isLoggedIn ? <MinimalLayout /> : <Navigate to="/dashboard/default" />,
        children: [
            { path: '', element: <AuthLogin3 /> }
        ]
    },
    {
        path: '/forgot',
        element: !isLoggedIn ? <MinimalLayout /> : <Navigate to="/login" />,
        children: [
            { path: '', element: <Forgot3 /> }
        ]
    },
    // Rotas públicas (acessíveis sem login)
    {
        path: '/politica-de-privacidade',
        element: <MinimalLayout />,
        children: [
            {
                path: '',
                element: <PoliticaPrivacidade />
            }
        ]
    },
    {
        path: '/politica-de-privacidade/exclusao-facebook',
        element: <MinimalLayout />,
        children: [
            {
                path: '',
                element: <PoliticaPrivacidadeFacebook />
            }
        ]
    },
    {
        path: '/termos-de-uso',
        element: <MinimalLayout />,
        children: [
            {
                path: '',
                element: <TermosUso />
            }
        ]
    },
    
    // Rotas protegidas com MainLayout
    {
        path: '/',
        element: isLoggedIn ? <MainLayout /> : <Navigate to="/login" />,
        children: [
            {
                path: '',
                element: <Navigate to="/dashboard/default" />
            },
            {
                path: 'dashboard/default',
                element: <DashboardDefault />
            },
            {
                path: 'utils/util-typography',
                element: <UtilsTypography />
            },
            {
                path: 'utils/util-color',
                element: <UtilsColor />
            },
            {
                path: 'utils/util-shadow',
                element: <UtilsShadow />
            },
            {
                path: 'icons/tabler-icons',
                element: <UtilsTablerIcons />
            },
            {
                path: 'icons/material-icons',
                element: <UtilsMaterialIcons />
            },
            {
                path: 'sample-page',
                element: <SamplePage />
            },
            {
                path: 'area-negocio',
                element: <ProtectedRoute element={<AreaNegocio />} path="/area-negocio" />
            },
            {
                path: 'area-negocio/form',
                element: <ProtectedRoute element={<AreaNegocioForm />} path="/area-negocio" />
            },
            {
                path: 'area-negocio/form/:id',
                element: <ProtectedRoute element={<AreaNegocioForm />} path="/area-negocio" />
            },
            {
                path: 'alcada-aprovacao',
                element: <ProtectedRoute element={<AlcadaAprovacao />} path="/alcada-aprovacao" />
            },
            {
                path: 'alcada-aprovacao/form',
                element: <ProtectedRoute element={<AlcadaAprovacaoForm />} path="/alcada-aprovacao" />
            },
            {
                path: 'alcada-aprovacao/form/:id',
                element: <ProtectedRoute element={<AlcadaAprovacaoForm />} path="/alcada-aprovacao" />
            },
            {
                path: 'produto',
                element: <ProtectedRoute element={<Produto />} path="/produto" />
            },
            {
                path: 'produto/form',
                element: <ProtectedRoute element={<ProdutoForm />} path="/produto" />
            },
            {
                path: 'produto/form/:id',
                element: <ProtectedRoute element={<ProdutoForm />} path="/produto" />
            },
            {
                path: 'loja',
                element: <ProtectedRoute element={<Loja />} path="/loja" />
            },
            {
                path: 'loja/form/:id',
                element: <ProtectedRoute element={<LojaForm />} path="/loja" />
            },
            {
                path: 'modalidade-frete',
                element: <ProtectedRoute element={<ModalidadeFrete />} path="/modalidade-frete" />
            },
            {
                path: 'modalidade-frete/form',
                element: <ProtectedRoute element={<ModalidadeFreteForm />} path="/modalidade-frete" />
            },
            {
                path: 'modalidade-frete/form/:id',
                element: <ProtectedRoute element={<ModalidadeFreteForm />} path="/modalidade-frete" />
            },
            {
                path: 'tabela-financiamento',
                element: <ProtectedRoute element={<TabelaFinanciamento />} path="/tabela-financiamento" />
            },
            {
                path: 'tabela-financiamento/form',
                element: <ProtectedRoute element={<TabelaFinanciamentoForm />} path="/tabela-financiamento" />
            },
            {
                path: 'tabela-financiamento/form/:id',
                element: <ProtectedRoute element={<TabelaFinanciamentoForm />} path="/tabela-financiamento" />
            },
            {
                path: 'forma-pagamento',
                element: <ProtectedRoute element={<FormaPagamento />} path="/forma-pagamento" />
            },
            {
                path: 'forma-pagamento/form',
                element: <ProtectedRoute element={<FormaPagamentoForm />} path="/forma-pagamento" />
            },
            {
                path: 'forma-pagamento/form/:id',
                element: <ProtectedRoute element={<FormaPagamentoForm />} path="/forma-pagamento" />
            },
            {
                path: 'bandeira',
                element: <ProtectedRoute element={<Bandeira />} path="/bandeira" />
            },
            {
                path: 'bandeira/form',
                element: <ProtectedRoute element={<BandeiraForm />} path="/bandeira" />
            },
            {
                path: 'bandeira/form/:id',
                element: <ProtectedRoute element={<BandeiraForm />} path="/bandeira" />
            },
            {
                path: 'seller',
                element: <ProtectedRoute element={<Seller />} path="/seller" />
            },
            {
                path: 'seller/form',
                element: <ProtectedRoute element={<CadSellerForm />} path="/seller" />
            },
            {
                path: 'seller/form/:id',
                element: <ProtectedRoute element={<CadSellerForm />} path="/seller" />
            },
            {
                path: 'grupo-economico',
                element: <ProtectedRoute element={<GrupoEcon />} path="/grupo-economico" />
            },
            {
                path: 'grupo-economico/form',
                element: <ProtectedRoute element={<GrupoEconForm />} path="/grupo-economico" />
            },
            {
                path: 'grupo-economico/form/:id',
                element: <ProtectedRoute element={<GrupoEconForm />} path="/grupo-economico" />
            },
            {
                path: 'filtro-produto',
                element: <ProtectedRoute element={<FiltroProduto />} path="/filtro-produto" />
            },
            {
                path: 'filtro-produto/form',
                element: <ProtectedRoute element={<FiltroProdutoForm />} path="/filtro-produto" />
            },
            {
                path: 'filtro-produto/form/:id',
                element: <ProtectedRoute element={<FiltroProdutoForm />} path="/filtro-produto" />
            },
            {
                path: 'tipo-promocao',
                element: <ProtectedRoute element={<TipoPromocao />} path="/tipo-promocao" />
            },
            {
                path: 'tipo-promocao/form',
                element: <ProtectedRoute element={<TipoPromocaoForm />} path="/tipo-promocao" />
            },
            {
                path: 'tipo-promocao/form/:id',
                element: <ProtectedRoute element={<TipoPromocaoForm />} path="/tipo-promocao" />
            },
            {
                path: 'tipo-promocao-campos',
                element: <ProtectedRoute element={<TipoPromocaoCampos />} path="/tipo-promocao-campos" />
            },
            {
                path: 'tipo-promocao-campos/form/:id',
                element: <ProtectedRoute element={<TipoPromocaoCamposForm />} path="/tipo-promocao-campos" />
            },
            {
                path: 'categoria-cliente',
                element: <ProtectedRoute element={<CategoriaCliente />} path="/categoria-cliente" />
            },
            {
                path: 'categoria-cliente/form',
                element: <ProtectedRoute element={<CategoriaClienteForm />} path="/categoria-cliente" />
            },
            {
                path: 'categoria-cliente/form/:id',
                element: <ProtectedRoute element={<CategoriaClienteForm />} path="/categoria-cliente" />
            },
            {
                path: 'tipo-atributo',
                element: <ProtectedRoute element={<TipoAtributo />} path="/tipo-atributo" />
            },
            {
                path: 'tipo-atributo/form',
                element: <ProtectedRoute element={<TipoAtributoForm />} path="/tipo-atributo" />
            },
            {
                path: 'tipo-atributo/form/:id',
                element: <ProtectedRoute element={<TipoAtributoForm />} path="/tipo-atributo" />
            },
            {
                path: 'valor-atributo',
                element: <ProtectedRoute element={<ValorAtributo />} path="/valor-atributo" />
            },
            {
                path: 'valor-atributo/form',
                element: <ProtectedRoute element={<ValorAtributoForm />} path="/valor-atributo" />
            },
            {
                path: 'valor-atributo/form/:id',
                element: <ProtectedRoute element={<ValorAtributoForm />} path="/valor-atributo" />
            },
            {
                path: 'dominio-comercial',
                element: <ProtectedRoute element={<DominioComercial />} path="/dominio-comercial" />
            },
            {
                path: 'dominio-comercial/form',
                element: <ProtectedRoute element={<DominioComercialForm />} path="/dominio-comercial" />
            },
            {
                path: 'dominio-comercial/form/:id',
                element: <ProtectedRoute element={<DominioComercialForm />} path="/dominio-comercial" />
            },
            {
                path: 'cadastro-promocao',
                element: <ProtectedRoute element={<CadastroPromocao />} path="/cadastro-promocao" />
            },
            {
                path: 'cadastro-promocao/form',
                element: <ProtectedRoute element={<CadastroPromocaoForm />} path="/cadastro-promocao" />
            },
            {
                path: 'cadastro-promocao/form/:id',
                element: <ProtectedRoute element={<CadastroPromocaoForm />} path="/cadastro-promocao" />
            },
            {
                path: 'cadastro-promocao/form/:id/:acao',
                element: <ProtectedRoute element={<CadastroPromocaoForm />} path="/cadastro-promocao" />
            },
            {
                path: 'aprovacao-pendente',
                element: <ProtectedRoute element={<AprovacaoPendente />} path="/aprovacao-pendente" />
            },
            {
                path: 'aprovacao-pendente/form/:id',
                element: <ProtectedRoute element={<AprovacaoPendenteForm />} path="/aprovacao-pendente" />
            },
            {
                path: 'calendario-status',
                element: <ProtectedRoute element={<CalendarioStatus />} path="/calendario-status" />
            },
            {
                path: 'geracao-cupom',
                element: <ProtectedRoute element={<GeracaoCupom />} path="/geracao-cupom" />
            },
            {
                path: 'geracao-cupom/form',
                element: <ProtectedRoute element={<GeracaoCupomForm />} path="/geracao-cupom" />
            },
            {
                path: 'geracao-cupom/form/:id',
                element: <ProtectedRoute element={<GeracaoCupomForm />} path="/geracao-cupom" />
            },
            {
                path: 'geracao-cupom/form/:id/:acao',
                element: <ProtectedRoute element={<GeracaoCupomForm />} path="/geracao-cupom" />
            },
            {
                path: 'cupom-atendimento',
                element: <ProtectedRoute element={<CupomAtendimento />} path="/cupom-atendimento" />
            },
            {
                path: 'cupom-atendimento/form',
                element: <ProtectedRoute element={<CupomAtendimentoForm />} path="/cupom-atendimento" />
            },
            {
                path: 'cupom-atendimento/form/:id',
                element: <ProtectedRoute element={<CupomAtendimentoForm />} path="/cupom-atendimento" />
            },
            {
                path: 'situacao-cupom',
                element: <ProtectedRoute element={<SituacaoCupom />} path="/situacao-cupom" />
            },
            {
                path: 'situacao-cupom/:id',
                element: <ProtectedRoute element={<SituacaoCupom />} path="/situacao-cupom/:id" />
            },
            {
                path: 'perfil-acesso',
                element: <ProtectedRoute element={<PerfilAcesso />} path="/perfil-acesso" />
            },
            {
                path: 'perfil-acesso/form',
                element: <ProtectedRoute element={<PerfilAcessoForm />} path="/perfil-acesso" />
            },
            {
                path: 'perfil-acesso/form/:id',
                element: <ProtectedRoute element={<PerfilAcessoForm />} path="/perfil-acesso" />
            },
            {
                path: 'cargo',
                element: <ProtectedRoute element={<Cargo />} path="/cargo" />
            },
            {
                path: 'cargo/form',
                element: <ProtectedRoute element={<CargoForm />} path="/cargo" />
            },
            {
                path: 'cargo/form/:id',
                element: <ProtectedRoute element={<CargoForm />} path="/cargo" />
            },
            {
                path: 'usuario',
                element: <ProtectedRoute element={<Usuario />} path="/usuario" />
            },
            {
                path: 'usuario/form',
                element: <ProtectedRoute element={<UsuarioForm />} path="/usuario" />
            },
            {
                path: 'usuario/form/:id',
                element: <ProtectedRoute element={<UsuarioForm />} path="/usuario" />
            },
            {
                path: 'transacao-sistema',
                element: <ProtectedRoute element={<TransacaoSistema />} path="/transacao-sistema" />
            },
            {
                path: 'transacao-sistema/form/:id',
                element: <ProtectedRoute element={<TransacaoSistemaForm />} path="/transacao-sistema" />
            },
            {
                path: 'reports/dashboard',
                element: <ProtectedRoute element={<ReportsDashboard />} path="/reports/dashboard" />
            },
            {
                path: 'reports/cupons',
                element: <ProtectedRoute element={<CuponsReport />} path="/reports/cupons" />
            },
            {
                path: 'simulador-promocao',
                element: <ProtectedRoute element={<SimuladorPromocao />} path="/simulador-promocao" />
            },
            {
                path: 'simulador-promocao/form',
                element: <ProtectedRoute element={<SimuladorPromocaoForm />} path="/simulador-promocao" />
            },
            {
                path: 'simulador-promocao/form/:id',
                element: <ProtectedRoute element={<SimuladorPromocaoForm />} path="/simulador-promocao" />
            },
            {
                path: 'geracao-cupom-controle-saldo',
                element: <ProtectedRoute element={<GeracaoCupomControleSaldo />} path="/geracao-cupom-controle-saldo" />
            },
            {
                path: 'geracao-cupom-multiplos-sellers',
                element: <ProtectedRoute element={<GeracaoCupomMultiplosSellers />} path="/geracao-cupom-multiplos-sellers" />
            },
            {
                path: 'inativacao-cupom',
                element: <ProtectedRoute element={<InativacaoCupom />} path="/inativacao-cupom" />
            },
            {
                path: 'lista-cupom',
                element: <ProtectedRoute element={<ListaCupom />} path="/lista-cupom" />
            },
            {
                path: 'parametro',
                element: <ProtectedRoute element={<Parametro />} path="/parametro" />
            },
            {
                path: 'parametro/form',
                element: <ProtectedRoute element={<ParametroForm />} path="/parametro" />
            },
            {
                path: 'parametro/form/:id',
                element: <ProtectedRoute element={<ParametroForm />} path="/parametro" />
            },
            {
                path: 'canal-venda',
                element: <ProtectedRoute element={<CanalVenda />} path="/canal-venda" />
            },
            {
                path: 'canal-venda/form',
                element: <ProtectedRoute element={<CanalVendaForm />} path="/canal-venda" />
            },
            {
                path: 'canal-venda/form/:id',
                element: <ProtectedRoute element={<CanalVendaForm />} path="/canal-venda" />
            },
            {
                path: 'lancamento-budget',
                element: <ProtectedRoute element={<LancamentoBudget />} path="/lancamento-budget" />
            },
            {
                path: 'documentacao',
                element: <MarkDown />
            },
            {
                path: 'comunicacao/campanhas',
                element: <ProtectedRoute element={<Campanha />} path="/comunicacao/campanhas" />
            },
            {
                path: 'comunicacao/campanhas/form',
                element: <ProtectedRoute element={<CampanhaForm />} path="/comunicacao/campanhas" />
            },
            {
                path: 'comunicacao/campanhas/form/:id',
                element: <ProtectedRoute element={<CampanhaForm />} path="/comunicacao/campanhas" />
            },
            {
                path: 'comunicacao/canais',
                element: <ProtectedRoute element={<CanaisDeComunicacao />} path="/comunicacao/canais" />
            },
            {
                path: 'comunicacao/canais/form',
                element: <ProtectedRoute element={<CanaisDeComunicacaoForm />} path="/comunicacao/canais" />
            },
            {
                path: 'comunicacao/canais/form/:id',
                element: <ProtectedRoute element={<CanaisDeComunicacaoForm />} path="/comunicacao/canais" />
            },
            {
                path: 'comunicacao/templates',
                element: <ProtectedRoute element={<TemplatesComunicacao />} path="/comunicacao/templates" />
            },
            {
                path: 'comunicacao/templates/form',
                element: <ProtectedRoute element={<TemplatesComunicacaoForm />} path="/comunicacao/templates" />
            },
            {
                path: 'comunicacao/templates/form/:id',
                element: <ProtectedRoute element={<TemplatesComunicacaoForm />} path="/comunicacao/templates" />
            }
        ]
    }
];

export default MainRoutes;